module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', [_c('i', {
    staticClass: "icon-graph icon"
  }), _vm._v(" "), _c('span', [_vm._v("BI")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f1e3703","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/menu/BI.vue
// module id = 1687
// module chunks = 18